// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"58ab5d62","239":"457d8a00","396":"4942f480","455":"5e4532ea","857":"ee1bfba8","977":"8f5c144e"}[chunkId] + ".chunk.js";
};